


















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Getter } from "vuex-class";
import { RatePlanTranslation } from "@/shared/models/ratePlanModel";
import { ListModel } from "@/shared/models/listModel";

@Component({
  components: {
    RightDrawer,
  },
})
export default class SpecialOfferDrawer extends Vue {
  @Prop() open?: boolean;
  @Prop() ratePlanId?: number;

  @Getter("language/language") language?: string;

  @Watch("open")
  async openChanged(fresh: boolean) {
    if (fresh && this.ratePlanId) {
      await this.loadDetails(this.ratePlanId);
    }
  }

  details: RatePlanTranslation[] = [];

  async loadDetails(ratePlanId: number) {
    const response = await this.axios.get<ListModel<RatePlanTranslation>>(
      `advancedSearch/GetSpecialOfferTranslations/${ratePlanId}`
    );
    this.details = response.data.result;
  }

  get ratePlanTranslation() {
    if(this.details && this.details.length > 0) {
      return this.details.find(x => x.cultureCode === this.language?.split("-")[0]) ?? null;
    }
    else {
      return new RatePlanTranslation();
    }
  }
}
